import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module17Nav = () => {
  const { module17 } = useSelector((state) => state.module17, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage = '/Module17Images/JourneyMap17-01.png';
    const mobileImage = '/Module17Images/JourneyMap17-01_phone.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module17Images/Unit4_Mod2BG_Final.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module17Images/Module17NavImages/Underwater_journeymap_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module17Images/Module17NavImages/Underwater_journeymap_Day${dayNumber}_1.png`;

    return {
      dayNumber,
      destiny: '/friendsbullies',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/friends_bullying/friends_bullying_instrumental.m4a',
    slides: [
      'influencers/${login.influencerid}/answer_affirmation.mp4',
      `userfiles/${module17.StudentID}/friends_bullying_celebration_surprise_5.mp4`,
      'appfiles/friends_bullying/practice_playground_intro.mp4',
      `userfiles/${module17.StudentID}/friends_bullies_practice_greet_5.mp4`,
      'appfiles/friends_bullying/practice_playground_greet.mp4',
      `userfiles/${module17.StudentID}/friends_bullies_practice_ask_5.mp4`,
      'appfiles/friends_bullying/practice_playground_answer.mp4',
      `userfiles/${module17.StudentID}/friends_bullies_practice_respond_5.mp4`,
      'appfiles/friends_bullying/practice_playground_ask.mp4',
      `userfiles/${module17.StudentID}/friends_bullies_practice_answer_5.mp4`,
      'appfiles/friends_bullying/practice_playground_respond.mp4',
      `userfiles/${module17.StudentID}/friends_bullying_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid3}/answer_affirmation.mp4`,
      `userfiles/${module17.StudentID}/friends_bullying_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid4}/answer_affirmation.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE17'
          module={module17}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit4'
          nextDestiny='/unit4'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={4}
          animal={MediaService.getImage('/Images/Button_DogHead.png', login)}
        />
      )}
    </>
  );
};
export default Module17Nav;
